import { ClipboardCopyButton } from '@neo/blocks/clipboard-copy-button'
import { Light as SyntaxHighlighter } from 'react-syntax-highlighter'
import js from 'react-syntax-highlighter/dist/esm/languages/hljs/javascript'
import json from 'react-syntax-highlighter/dist/esm/languages/hljs/json'

SyntaxHighlighter.registerLanguage('javascript', js)
SyntaxHighlighter.registerLanguage('json', json)

interface CodeBlockProps {
  code: string
  language?: string
  showCopyButton?: boolean
  clipboardCopyButtonPosition?: 'topRight' | 'bottomRight'
}

export const CodeBlock = ({
  code,
  language = 'javascript',
  showCopyButton = true,
  clipboardCopyButtonPosition = 'bottomRight',
}: CodeBlockProps) => (
  <div className="relative group">
    <SyntaxHighlighter
      language={language}
      useInlineStyles={false}
      className="w-full min-w-full overflow-x-auto rounded-md border border-border bg-hv1 p-4 font-jetbrains text-s-400 [&_code]:font-jetbrains [&_code]:!text-foreground [&_.hljs-comment]:text-secondary [&_.hljs-comment]:italic [&_.hljs-quote]:text-secondary [&_.hljs-keyword]:text-foreground [&_.hljs-keyword]:text-s-600 [&_.hljs-literal]:text-foreground [&_.hljs-literal]:text-s-600 [&_.hljs-attr]:text-foreground [&_.hljs-attribute]:text-foreground [&_.hljs-name]:text-foreground [&_.hljs-string]:text-foreground [&_.hljs-number]:text-foreground [&_.hljs-title]:text-foreground"
    >
      {code}
    </SyntaxHighlighter>
    {showCopyButton && (
      <ClipboardCopyButton
        textToCopy={code}
        aria-label="Copy code"
        tooltipText="Copy code"
        data-testid="btn-copy-code"
        position={clipboardCopyButtonPosition}
      />
    )}
  </div>
)
